import { AfterViewInit, Component, Input, OnInit, ViewChildren, QueryList, ElementRef, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { FwcDatePicker } from '../../../../fwc-lib.js';
import moment from 'moment';

@Component({
    selector: 'app-add-dependent-form',
    templateUrl: './add-dependent-form.component.html',
    styleUrls: ['./add-dependent-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class AddDependentFormComponent implements OnInit, AfterViewInit {
    @Input() content: any;
    @Input() addDependentFormData: any;
    @Input() isMyAccount: any = false;
    @Input() aboutYou: any;
    @ViewChildren('depHeader', { read: ElementRef }) depHeaders: QueryList<ElementRef>;
    dependentsForm: UntypedFormGroup;
    datePickerStart: any = ['02/16/2022', '05/16/2022'];
    showStartDate = true;
    formSubmitted = false;
    ageError = [];
    ageErrorFound = false;
    dateRange: any;
    constructor(
        private formBuilder: UntypedFormBuilder,
        private host: ElementRef
    ) {
    }

    ngOnInit(): void {
        const fwcDatePicker = new FwcDatePicker();
        fwcDatePicker.build();
        this.dependentsForm = this.formBuilder.group({
            dependent: this.formBuilder.array([])
        });
        this.dateRange = JSON.stringify(['01/01/1922', new Date()]);
        if (this.addDependentFormData && this.addDependentFormData.dependent && this.addDependentFormData.dependent.length > 0) {
            this.setExistingData();
        } else {
            this.addDependent().push(this.newQuantity());
        }
    }
    ngAfterViewInit(): void {
        this.addPlacementNumbers();
    }

    get form(): { [p: string]: AbstractControl } { return this.dependentsForm.controls; }

    addDependent(): UntypedFormArray {
        const dependents = 'dependent';
        return this.dependentsForm.get(dependents) as UntypedFormArray;
    }

    countArray(): number {
        const visualArray = [];
        for (const dependents of this.addDependent().controls) {
            const dependentValue = dependents.get('action').value;
            if (dependentValue !== 'delete') {
                visualArray.push(dependentValue);
            }
        }
        return visualArray.length;
    }

    addPlacementNumbers(): void {
        this.depHeaders.forEach((title, index) => {
            title.nativeElement.innerHTML = 'Dependent ' + (index + 1);
        });
    }

    newQuantity(): UntypedFormGroup {
        return this.formBuilder.group({
            id: [''],
            action: ['update'],
            type: ['', Validators.required],
            firstName: ['', Validators.required],
            middleInitial: [''],
            lastName: ['', Validators.required],
            gender: ['', Validators.required],
            identityAs: [''],
            DOB: ['', Validators.required],
            email: ['', Validators.email],
            phone: [''],
        });
    }

    addQuantity(): void {
        this.addDependent().push(this.newQuantity());
        setTimeout(() => {
            this.addPlacementNumbers();
        }, 10);
    }

    removeQuantity(i: number): void {
        const formArrayElement: any = this.addDependent().at(i);
        if (formArrayElement.controls.action.value) {
            formArrayElement.controls.action.setValue('delete');
        }
        if (this.isMyAccount) {
            this.addDependent().removeAt(i);
        }
        this.ageError.splice(i, 1);
        this.ageErrorFound = this.ageError.includes(true);
        setTimeout(() => {
            this.addPlacementNumbers();
        }, 10);
    }

    onSubmitForm(): void {
        this.formSubmitted = true;
    }

    updateDob(e, index): void {
        const dob = moment(e.detail).format('MM/DD/YYYY');
        const data = ((this.dependentsForm.get('dependent') as UntypedFormArray).at(index) as UntypedFormGroup);
        const dateOfBirth = 'DOB';
        data.controls[dateOfBirth].setValue(dob);
        this.validateDate(dob, index);
    }

    blurEvent(e, index): void {
        this.validateDate(e, index);
    }

    validateDate(e, index): void {
        const isDateValid = moment(e, 'MM/DD/YYYY', true).isValid();
        const dateOfBirth = 'DOB';
        const isInRange = this.isDateInRange(e);
        const isCurrentDate = this.isDateInRangeCurrent(e);
        this.dobvalidation(e, index);
        const data = ((this.dependentsForm.get('dependent') as UntypedFormArray).at(index) as UntypedFormGroup);
        if (!isDateValid || !isInRange || !isCurrentDate) {
            data.controls[dateOfBirth].setErrors({ 'invalid date': true });
            data.controls[dateOfBirth].setValue('');
        } else {
            data.controls[dateOfBirth].setErrors(null);
        }
    }
    isDateInRange(date): boolean {
        return moment(date, 'MM/DD/YYYY').isAfter('01/01/1922');
    }
    isDateInRangeCurrent(date): boolean {
        return moment(date, 'MM/DD/YYYY').isBefore(moment());
    }

    setExistingData(): void {
        this.addDependentFormData.dependent.forEach(element => {
            this.addQuantity();
        });
        this.dependentsForm.patchValue(this.addDependentFormData);
    }

    dobvalidation(dob, index): void {
        const greaterThanToday = moment(dob, 'MM/DD/YYYY').isAfter(new Date());
        if (greaterThanToday) {
            this.ageError[index] = true;
        } else {
            this.ageError[index] = false;
        }
        this.ageErrorFound = this.ageError.includes(true);
    }


}
